import React from 'react'
import injectSheet from 'react-jss'
import ImageBox from 'pobble-components/dist/image-box'
import classNames from 'classnames'
import ScrollFade from '../scroll-fade/scroll-fade.jsx'
import { withPresentation } from '../../presentation-connectors'

const IMAGE_COLUMN = {
  small: '67%',
  medium: '64%',
  large: '61%'
}

const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex'
  },
  reverse: {
    flexDirection: 'row-reverse'
  },
  textColumn: {
    flex: '1',
    position: 'relative'
  },
  textHolder: ({ size }) => ({
    padding: `${size(3.5)} ${size(4)}`,
    overflow: 'auto',
    height: '100%'
  }),
  imageColumn: ({ fontSize }) => ({
    background: '#DDE3EB',
    width: IMAGE_COLUMN[fontSize]
  })
}

const ColumnsLayout = ({
  classes,
  children,
  image,
  alt,
  reverse,
  className
}) => (
  <div
    className={classNames(
      classes.container,
      { [classes.reverse]: reverse },
      className
    )}>
    <div className={classes.textColumn}>
      <div className={classes.textHolder}>{children}</div>
      <ScrollFade />
    </div>
    <div className={classes.imageColumn}>
      <ImageBox src={image} alt={alt} />
    </div>
  </div>
)

export default withPresentation(injectSheet(styles)(ColumnsLayout))
